import { render, staticRenderFns } from "./OverWeightMale.vue?vue&type=template&id=199b0d3d&scoped=true&"
import script from "./OverWeightMale.vue?vue&type=script&lang=js&"
export * from "./OverWeightMale.vue?vue&type=script&lang=js&"
import style0 from "./OverWeightMale.vue?vue&type=style&index=0&id=199b0d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b0d3d",
  null
  
)

export default component.exports